// extracted by mini-css-extract-plugin
module.exports = {"container":"NT","links":"OT"};